<template>
    <v-layout column align-center>
        <p class="headline font-weight-bold mb-3 text-center primary--text">
            View time range of trips matching your selection
        </p>
        <span style="margin: 0 16px 0 16px">
            You can view the time range of available trips you have subscribed to here. You will receive a notification for the ETA of every trip within this time range. If no trips are scheduled within your selected time range you will see a warning. Please refer to the timetable and modify the time range accordingly.
        </span>
    </v-layout>
</template>

<script>
    export default {
        data: () => ({

        }),
    };
</script>
<style scoped>
    > > > img {
        border: 1px solid black;
        max-width: 100%;
    }

    > > > p {
        margin: 0 16px 0 16px;
    }

    @media screen and (min-width: 600px) {
        > > > img {
            margin: 12px;
        }
    }
</style>
